namespace SPA
{
	export namespace BWS
	{
		export namespace data
		{

			export class BWSTableDataReader
				extends ui.table.DataReader< Wollmilch.BWS.IBWS >
			{
				public constructor()
				{
					super();
				}

				public GenerateDataField( BWSData: Wollmilch.BWS.IBWS ): JQuery<HTMLElement>
				{
					const link = $(
						new Button(
							{
								on:
								{
									click: () =>
									{
										app.getGlobalTabControl().addTab(
											BWSData.ObjectNumber,
											new SPA.BWS.Page( BWSData ),
											true,
										);
									},
								},
								style: 'link',
								title: BWSData.ObjectNumber,
							},
						).getElement(),
					).removeClass( 'btn' );

					return new ui.base.BaseHTMLElement( 'tr' )
						.append( new ui.base.BaseHTMLElement( 'td' ).append( link ) )
						.append( new ui.base.BaseHTMLElement( 'td' )
							.append( BWSData.Object && BWSData.Object.Address
								? BWSData.Object.Address.display
								: app.getMessage( 'BWS.TABLE.not_founded' ),
							),
						)
						.append( new ui.base.BaseHTMLElement( 'td' )
							.append( BWSData.caseNumber ? BWSData.caseNumber : app.getMessage( 'BWS.TABLE.not_founded' ) ),
						)
						.append( new ui.base.BaseHTMLElement( 'td' )
							.append( BWSData.CreatedAt ? new Date(BWSData.CreatedAt).pattern( 'd.m.Y H:i' ) : '' ),
						)
					.Root();
				}
			}

		}
	}
}
